package com.patronat.top.features.auth.presentation

import com.arkivanov.decompose.ComponentContext
import com.patronat.top.dto.UserRole

class DefaultAuthComponent(
    componentContext: ComponentContext,
    private val onLoginSuccess: (UserRole) -> Unit
) : AuthComponent, ComponentContext by componentContext {


    override fun onLoginClicked(userRole: UserRole) {
        onLoginSuccess(userRole)
    }
}